const env = process.env.API_ENV || "development";

const urls = {
  production: {
    LUCINA_URL: "https://api-lucina.com",
    SITE_URL: "https://www.thesciencespotlight.com",
  },
  staging: {
    LUCINA_URL: "https://internal.minerva.dev/staging/lucina-api",
    SITE_URL: "",
  },
  development: {
    LUCINA_URL: "http://localhost:8080",
    SITE_URL: "http://localhost:3000",
  },
};

const { LUCINA_URL, SITE_URL } = urls[env];

const NEWSLETTER_DOMAIN = "newsletter@thesciencespotlight.com";

const LUCINA_DOMAIN = "thesciencespotlight.com";

let ROUTER_BASENAME; // eslint-disable-line
switch (process.env.API_ENV) {
  case `staging`:
    ROUTER_BASENAME = `/staging/the-science-spotlight`;
    break;
  case `production`:
    ROUTER_BASENAME = ``;
    break;
  default:
    ROUTER_BASENAME = ``;
}

const GHOST_URL = `https://starter.minervaarticles.com`;
const GHOST_KEY = `84c70cb9d034868a896be02e6d`;

const GOOGLE_ANALYTICS_TAG = ``;

module.exports = {
  NEWSLETTER_DOMAIN,
  LUCINA_URL,
  SITE_URL,
  LUCINA_DOMAIN,
  ROUTER_BASENAME,
  GOOGLE_ANALYTICS_TAG,
  GHOST_URL,
  GHOST_KEY,
};
